import React from 'react'
import Autocomplete from '@mui/material/Autocomplete';
import Controls from './Controls';
import { withStyles } from '@mui/styles';

export default function NoPaddingAutocomplete(props) {

    const { text, options, getOptionLabel, getOptionSelected, onChange, onBlur, value, width, disabled,
        required, error=null, helperText=error } = props;

    const DinAutocomplete = withStyles({
        inputRoot: {
            '&&[class*="MuiOutlinedInput-root"] $input': {
                padding: 0
            },
            '&&[class*="MuiOutlinedInput-root"]': {
                padding: 5
            }
        },
        input: {}
    })(Autocomplete);

    return (
        <DinAutocomplete
            style={{ width: width }}
            getOptionLabel={getOptionLabel}
            options={options}
            value={value}
            onChange={onChange}
            renderInput={(params) =>
                <Controls.Input
                    {...(error && { error: true, helperText: error })}
                    helperText={error ? helperText : ''}
                    {...params}
                    onBlur={onBlur}
                    label={text}
                    variant="outlined"
                    required={required} />
            }
            disabled={disabled}
        />
    )
}
